import { ViewFactory } from 'cube-react'

import { registerViews as registerMainViews } from './main/view'
import { registerViews as registerBulasViews } from './analise-bulas/view'
import { registerViews as registerReacoesViews } from './analise-reacoes/view'

export function registerAllViews() {
    const rr = ViewFactory.register

    registerMainViews(rr)
    registerBulasViews(rr)
    registerReacoesViews(rr)
}